(function ($) {
    $(document).ready(function() {
        // Event sin entradilla con imagen centrada
        if($('.event .highlight .block-intro').length == 0){
            $('.event .highlight .col-lg-6 .block .event__image').parent().addClass('d-flex justify-content-center')
            $('.event .highlight .col-lg-6').removeClass('col-lg-6')
        }
        if(drupalSettings.path.currentLanguage != 'en'){
            if(drupalSettings.path.currentLanguage == 'es'){
                var presentation = 'Presentación';
                var registration = 'Registro';
                var venue = 'Localización';
            }else if(drupalSettings.path.currentLanguage == 'ca'){
                var presentation = 'Presentació';
                var registration = 'Inscripció';
                var venue = 'Localització';
            }
            $('.nav-tabs .nav-item .nav-link:contains(Presentation)').text(presentation);
            $('.tab h2:contains(Presentation)').text(presentation);
            $('.nav-tabs .nav-item .nav-link:contains(Registration)').text(registration);
            $('.tab h2:contains(Registration)').text(registration);
            $('.nav-tabs .nav-item .nav-link:contains(Venue)').text(venue);
            $('.tab h2:contains(Venue)').text(venue);
        }
    });
})(jQuery, Drupal);